<script>
export default {
    name: 'MessageContentText',
    props: {
        isVisitor: {
            type: Boolean
        },
        content: {
            type: Object
        },
        time: {
            type: String
        }
    }
}
</script>

<template>
    <div class="d-flex flex-column">
        <div :class="{'visitorMsg': isVisitor, 'otherMsg': !isVisitor}">{{ content.text }}</div>
        <div class="d-flex flex-column" style="gap: 8px">
            <span class="chat-time" :class="{'align-self-end': !isVisitor}">{{ time | formatTimeHM }}</span>
            <button class="btn" v-for="btn of content.buttons" :key="btn.title">
                {{ btn.title }}
            </button>
        </div>
    </div>
</template>

<style scoped lang="scss">
.visitorMsg {
    padding: 10px;
    background-color: white;
    border: 1px solid #EDEDED;
    border-radius: 6px;
}

.otherMsg {
    padding: 10px;
    border-radius: 6px;
    border: 1px solid #D6D6D6;
    background: #E6E6E6;
    white-space: pre-line;
    -webkit-box-align: center;
    word-break: break-all;
}

.btn {
    border-radius: 4px;
    border: 1px solid #EDEDED;
    background: #FFF;
    height: 30px;
    padding: 0px 12px;
    font-weight: bold;
}

.chat-time {
    color: #7B7B7B;
    font-size: 12px;
}
</style>
